import React from 'react';
import Board from './components/Board';

const App = () => {
  return (
    <div className="bg-white dark:bg-black min-h-screen">
      <div className="bg-opacity-60 bg-zinc-100 dark:bg-zinc-900 dark:bg-opacity-60 min-h-screen">
        <Board />
      </div>
    </div>
  );
}

export default App;
